<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="flex flex-col items-center w-full gap-3 md:items-start">
      <h2 class="mb-4 text-xl font-bold text-gray-900 dark:text-white text-center">Gestión de Inventario</h2>

      <button @click="abrirModal"
        class="inline-flex w-min whitespace-nowrap items-center px-5 py-2.5 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
        Crear medicamento
      </button>

      <!-- Modal -->
      <div v-if="mostrarModal" @click.self="cerrarModal"
        class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-gray-900 bg-opacity-50">
        <div class="relative w-full max-w-2xl p-6 bg-white rounded-lg shadow dark:bg-gray-700">
          <form @submit.prevent="agregarOModificarMedicamento" class="space-y-6">
            <h3 class="text-xl font-medium text-gray-900 dark:text-white">
              Crear/Editar Medicamento
            </h3>
            <div class="grid gap-4 sm:grid-cols-2 sm:gap-6">
              <div class="sm:col-span-2">
                <label for="nombre" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Nombre del Medicamento
                </label>
                <input v-model="nombre" list="medicamentos-list" type="text" id="nombre"
                  class="block w-full p-2.5 text-sm text-gray-900 bg-gray-50 border border-gray-300 rounded-lg focus:ring-primary-600 focus:border-primary-600 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  placeholder="Seleccionar o escribir un nuevo medicamento" required />
                <datalist id="medicamentos-list">
                  <option v-for="med in medicamentosExistentes" :key="med.id" :value="med.nombre">
                    {{ med.nombre }}
                  </option>
                </datalist>
              </div>
              <div>
                <label for="cantidad" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Cantidad dosis por frasco
                </label>
                <input v-model="cantidad" @input="calcularCostoPorDosis" type="number" step="any" id="cantidad"
                  class="block w-full p-2.5 text-sm text-gray-900 bg-gray-50 border border-gray-300 rounded-lg focus:ring-primary-600 focus:border-primary-600 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  required />
              </div>
              <div>
                <label for="miligramos" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Miligramos por frasco
                </label>
                <input v-model="miligramos" type="number" id="miligramos" step="0.01"
                  class="block w-full p-2.5 text-sm text-gray-900 bg-gray-50 border border-gray-300 rounded-lg focus:ring-primary-600 focus:border-primary-600 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  required />
              </div>
              <div>
                <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Dosis totales
                  </label>
                <input v-model="dosisPorFrasco" type="number" step="any"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" />
              </div>
              <div>
                <label for="dosis" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Miligramos por
                  dosis</label>
                <input v-model="miligramosPorDosis"  type="number" id="dosis" step="any"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  required />
              </div>
              <div class="w-full">
                <label for="costoPorFrasco" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Costo
                  por Frasco</label>
                <input v-model="costoPorFrasco" @input="calcularCostoPorDosis" type="number" id="costoPorFrasco"
                  step="any"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  required />
              </div>
             
              <div class="w-full">
                <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Costo por Dosis
                  (calculado)</label>
                <input type="text" :value="'$' + costoPorDosis" readonly step="any"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" />
              </div>


            </div>
            <div class="flex justify-end space-x-4">
              <button @click="cerrarModal" type="button"
                class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-700 dark:bg-gray-600 dark:hover:bg-gray-700 dark:text-white">
                Cerrar
              </button>
              <button type="submit"
                class="inline-flex items-center px-5 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800">
                Guardar Medicamento
              </button>
            </div>
          </form>
        </div>
      </div>


      <!--Modal Imagen-->
      <div>

        <!-- Modal para mostrar y subir imagen -->
        <div v-if="modalAbierto" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white p-6 rounded-lg max-w-lg w-full space-y-4">
            <div class="flex justify-end">
              <button @click="cerrarModalImagen" class="text-xl text-gray-500 hover:text-gray-700">&times;</button>
            </div>

            <!-- Mostrar la imagen actual o la imagen de un medicamento -->
            <div v-if="urlImagen">
              <img :src="urlImagen" alt="Imagen actual" class="max-w-1/3 h-12 mx-auto" />
            </div>
            <div v-else>
              <!-- <img v-if="vistaPrevia" :src="vistaPrevia" alt="Vista previa" class="max-w-1/3 h-12 mx-auto" /> -->
              <img v-if="!vistaPrevia && itemSeleccionado.img" :src="itemSeleccionado.img" alt="Imagen de medicamento" class="max-w-1/3 h-auto mx-auto" />
            </div>

            <!-- Formulario para cargar la imagen -->
            <div>
              <input type="file" @change="previsualizarImagen" accept="image/*"
                class="w-full py-2 px-4 border border-gray-300 rounded-md" />
            </div>

            <!-- Vista previa de la imagen -->
            <div v-if="vistaPrevia">
              <p class="text-center text-gray-600">Vista previa:</p>
              <img :src="vistaPrevia" alt="Vista previa" class="max-w-full h-auto mx-auto" />
            </div>

            <!-- Botones -->
            <div class="flex justify-between">
              <button @click="guardarImagen"
                class="py-2 px-4 bg-blue-700 text-white rounded-md hover:bg-blue-600">Guardar Imagen</button>
              <button @click="cerrarModalImagen"
                class="py-2 px-4 bg-red-500 text-white rounded-md hover:bg-red-600">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Lista de Inventario -->
      <div class="flex flex-col w-full overflow-x-auto">
        <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-4 text-center">Inventario de Medicamentos</h2>
        <div class="w-full relative overflow-x-auto">
          <table class="min-w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3">Nombre</th>
                <th scope="col" class="px-6 py-3">Cant. Frascos (calculado)</th>
                <th scope="col" class="px-6 py-3">Cant. Dosis por Frasco</th>
                <th scope="col" class="px-6 py-3">Mg/Frasco</th>
                <th scope="col" class="px-6 py-3">Mg/Dosis</th>
                <th scope="col" class="px-6 py-3">Dosis Totales</th>
                <th scope="col" class="px-6 py-3">Costo/Frasco</th>
                <th scope="col" class="px-6 py-3">Costo/Dosis</th>
                <!-- <th scope="col" class="px-6 py-3">Precio Venta/Dosis</th> -->
                <th scope="col" class="px-6 py-3">Estado</th>
                <th scope="col" class="px-6 py-3">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in inventario" :key="item.id"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <td class="px-6 py-4">{{ item.nombre }}</td>
                <td class="px-6 py-4">{{ item.unidad }}</td>
                <td class="px-6 py-4">{{ item.cantidad }}</td>
                <td class="px-6 py-4">{{ item.miligramos }}</td>
                <td class="px-6 py-4">{{ item.miligramosPorDosis }}</td>
                <td class="px-6 py-4">
                  <span v-if="item.dosisPorFrasco > 0">{{ item.dosisPorFrasco }}</span>
                  <span v-else class="text-red-500 font-bold">Sin Stock</span>
                </td>
                <td class="px-6 py-4">${{ item.costoPorFrasco }}</td> 
                <!-- <td class="px-6 py-4">${{ item.precioVentaPorDosis }}</td> -->
                <td class="px-6 py-4">${{ item.costoPorDosis }}</td>
                <td class="px-6 py-4">
                  <span
                    :class="{ 'text-green-500': item.cantidad > 0 && item.dosisPorFrasco > 0, 'text-red-500': item.cantidad === 0 || item.dosisPorFrasco === 0 }">
                    {{ item.cantidad > 0 && item.dosisPorFrasco > 0 ? 'Disponible' : 'Agotado' }}
                  </span>
                </td>
                <td class="flex flex-col w-full items-center px-6 py-4">
                  <button @click="editarMedicamento(item)" class="text-blue-600 hover:underline dark:text-blue-500">
                    Editar
                  </button>
                  <button @click="abrirModalImagen(item)" class="text-blue-600 hover:underline dark:text-blue-500">
                    Imagen
                  </button>
                  <button @click="eliminarMedicamento(item.id)"
                    class="text-red-600 hover:underline dark:text-red-500 ml-2">
                    Eliminar
                  </button>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div id="toast-container" class="fixed top-5 right-5 space-y-2"></div>

  </section>
</template>
<script>
import { collection, addDoc, getDocs, deleteDoc, updateDoc, doc } from "firebase/firestore";
import { db, } from '../../firebase';

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Asegúrate de importar estas funciones

const storage = getStorage();

export default {
  name: "GestionInventario",
  data() {
    return {
      nombre: '',
      cantidad: 0,
      miligramos: 0,
      miligramosPorDosis: 0,
      dosisPorFrasco: 0,
      costoPorFrasco: 0,
      margenGanancia: 0,
      costoPorDosis: 0,
      precioVentaPorDosis: 0,
      estado: true,
      editandoId: null,
      textoBoton: 'Crear Medicamento',
      mostrarModal: false,
      modalAbierto: false,
      urlImagen: '',
      vistaPrevia: '',
      itemSeleccionado: null,
      inventario: [],
      archivoSeleccionado: null,
    };
  },
  methods: {

    // Nueva función para actualizar el costo por dosis de todos los medicamentos
    async actualizarCostoPorDosis() {
      try {
        // Obtener todos los medicamentos
        const querySnapshot = await getDocs(collection(db, "medicamentos"))
        const medicamentos = querySnapshot.docs

        this.totalMedicamentos = medicamentos.length
        this.medicamentosProcesados = 0
        this.mostrarModalProcesamiento = true

        // Procesar cada medicamento
        for (const doc of medicamentos) {
          const medicamento = doc.data()
          const medicamentoId = doc.id

          // Calcular el costo por dosis
          let costoPorDosis = 0
          if (medicamento.costoPorFrasco > 0 && medicamento.cantidad > 0) {
            costoPorDosis = Number((medicamento.costoPorFrasco / medicamento.cantidad).toFixed(2))
          }

          // Actualizar el documento en Firestore
          const medicamentoRef = doc(db, "medicamentos", medicamentoId)
          await updateDoc(medicamentoRef, {
            costoPorDosis: costoPorDosis,
          })

          this.medicamentosProcesados++
        }

        this.mostrarModalProcesamiento = false
        alert("¡Todos los costos por dosis han sido actualizados correctamente!")

        // Recargar el inventario para mostrar los cambios
        this.cargarInventario()
      } catch (error) {
        this.mostrarModalProcesamiento = false
        console.error("Error al actualizar los costos por dosis:", error)
        alert("Ocurrió un error al actualizar los costos por dosis. Por favor, intenta nuevamente.")
      }
    },

    // Abrir el modal
    abrirModalImagen(item) {
      this.itemSeleccionado = item;
      this.modalAbierto = true;
      this.urlImagen = item.img || null;
      this.archivoSeleccionado = null; 
        this.vistaPrevia = null;
    },

    // Cerrar el modal
    cerrarModalImagen() {
      this.modalAbierto = false;
      this.vistaPrevia = ''; // Limpiar la vista previa al cerrar
    },

    // Manejar el cambio de la imagen
    // previsualizarImagen(event) {
    //   const archivo = event.target.files[0];
    //   if (archivo) {
    //     const lector = new FileReader();
    //     lector.onloadend = () => {
    //       this.vistaPrevia = lector.result;
    //     };
    //     lector.readAsDataURL(archivo);
    //   }
    // },

    previsualizarImagen(event) {
      const archivo = event.target.files[0]; // Obtiene el archivo seleccionado
      if (archivo) {
        this.archivoSeleccionado = archivo; // Almacena el archivo original
        this.vistaPrevia = URL.createObjectURL(archivo); // Crea una URL temporal para la vista previa
      }
    },

    // Guardar la nueva imagen
    // guardarImagen() {
    //   // Aquí va la lógica para guardar la imagen, por ejemplo, subiéndola al servidor.
    //   // Puedes reemplazar `this.urlImagen` con la URL de la nueva imagen una vez que se haya guardado.
    //   if (this.vistaPrevia) {
    //     this.urlImagen = this.vistaPrevia;
    //     // medicamento.img  = url
    //     // updateDoc()
    //     alert('Imagen guardada exitosamente');
    //   } else {
    //     alert('Por favor, seleccione una imagen para guardar.');
    //   }
    //   this.cerrarModal();
    // },

    async guardarImagen() {
  if (this.archivoSeleccionado) { // Verifica que haya un archivo seleccionado
    const file = this.archivoSeleccionado; // Aquí deberías tener el archivo original
    const storageReference = ref(storage, `images/${file.name}`); // Crea una referencia a la ubicación donde deseas almacenar la imagen

    try {
      await uploadBytes(storageReference, file); // Subir la imagen
      const url = await getDownloadURL(storageReference); // Obtener la URL de descarga
      this.urlImagen = url; // Guardar la URL para mostrarla

      const medicamentoRef = doc(db, "medicamentos", this.itemSeleccionado.id);
      await updateDoc(medicamentoRef, {
        ...this.itemSeleccionado,
        img: this.urlImagen // Guardar la URL de la imagen
      });

      alert('Imagen guardada exitosamente');
    } catch (error) {
      console.error('Error al guardar la imagen:', error);
    }
  } else {
    alert('Por favor, seleccione una imagen para guardar.'); // Mensaje si no hay archivo seleccionado
  }
  this.cerrarModalImagen(); // Cierra el modal después de intentar guardar la imagen
},


    abrirModal() {
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.limpiarFormulario();
    },
    editarMedicamento(medicamento) {
  if (!medicamento) {
    console.error('No se ha recibido el medicamento');
    return;
  }
  


  this.nombre = medicamento.nombre || '';
  this.cantidad = medicamento.cantidad || 0;
  this.miligramos = medicamento.miligramos || 0;
  this.miligramosPorDosis = medicamento.miligramosPorDosis || 0;
  this.dosisPorFrasco = medicamento.dosisPorFrasco || 0;
  this.costoPorFrasco = medicamento.costoPorFrasco || 0;
  this.margenGanancia = medicamento.margenGanancia ?? 0;
  this.costoPorDosis = medicamento.costoPorDosis || 0;
  this.precioVentaPorDosis = medicamento.precioVentaPorDosis || 0;
  this.estado = medicamento.estado ?? true;
  this.urlImagen = medicamento.img || ''; // Cargar la imagen existente

  this.editandoId = medicamento.id;
  this.textoBoton = 'Editar Medicamento';
  this.mostrarModal = true;
},
    
    calcularCostoPorDosis() {
      if (this.costoPorFrasco > 0 && this.cantidad > 0) {
        this.costoPorDosis = Number((this.costoPorFrasco / this.cantidad).toFixed(2));
        // this.precioVentaPorDosis = Number((this.costoPorDosis * (1 + this.margenGanancia / 100)).toFixed(2));
      } else {
        this.costoPorDosis = 0;
        // this.precioVentaPorDosis = 0;
      }
    },
    eliminarMedicamento(medicamentoId) {
      if (!medicamentoId) {
        console.error('El ID del medicamento no es válido.');
        return;
      }

      if (confirm('¿Estás seguro de que deseas eliminar este medicamento?')) {
        const medicamentoRef = doc(db, "medicamentos", medicamentoId);
        deleteDoc(medicamentoRef)
          .then(() => {
            alert("Medicamento eliminado con éxito!");
            this.cargarInventario();
          })
          .catch((error) => {
            console.error("Error al eliminar el medicamento: ", error);
          });
      }
    },
    async cargarMedicamentosExistentes() {
      const querySnapshot = await getDocs(collection(db, "medicamentos"));
      this.medicamentosExistentes = querySnapshot.docs.map(doc => ({
        id: doc.id,
        nombre: doc.data().nombre,
        cantidad: doc.data().cantidad,
        estado: doc.data().estado
      }));
    },
    async agregarOModificarMedicamento() {
  const medicamentoData = {
    nombre: this.nombre,
    cantidad: this.cantidad,
    miligramos: this.miligramos,
    miligramosPorDosis: this.miligramosPorDosis,
    dosisPorFrasco: this.dosisPorFrasco,
    costoPorFrasco: this.costoPorFrasco,
    margenGanancia: this.margenGanancia,
    costoPorDosis: this.costoPorDosis,
    precioVentaPorDosis: this.precioVentaPorDosis,
    estado: this.estado,
    img: this.urlImagen // Mantener la imagen existente o la nueva
  };

  if (this.editandoId) {
    // Si estamos editando, actualizamos el medicamento
    const medicamentoRef = doc(db, "medicamentos", this.editandoId);
    await updateDoc(medicamentoRef, medicamentoData);
    alert("Medicamento actualizado con éxito!");
  } else {
    // Si no hay ID, creamos un nuevo medicamento
    try {
      await addDoc(collection(db, "medicamentos"), medicamentoData);
      alert("Medicamento agregado con éxito!");
    } catch (e) {
      console.error("Error al agregar el medicamento: ", e);
    }
  }

  this.limpiarFormulario();
  this.cargarInventario();
  this.cerrarModal();
},

    limpiarFormulario() {
      this.nombre = "";
      this.cantidad = 0;
      this.miligramos = 0;
      this.miligramosPorDosis = 0;
      this.dosisPorFrasco = 0;
      this.costoPorFrasco = 0;
      this.margenGanancia = 0;
      this.costoPorDosis = 0;
      this.precioVentaPorDosis = 0;
      this.estado = true;
      this.editandoId = null; // Limpiamos el ID del medicamento
      this.textoBoton = 'Crear Medicamento'; // Restablecemos el texto del botón
    },
    
    async cargarInventario() {
      const querySnapshot = await getDocs(collection(db, "medicamentos"));
      this.inventario = [];
      
      // Procesar cada medicamento
      for (const docSnapshot of querySnapshot.docs) {
        const medicamentoData = docSnapshot.data();
        const medicamentoId = docSnapshot.id;
        
        // Calcular el costo por dosis
        let costoPorDosis = 0;
        if (medicamentoData.costoPorFrasco > 0 && medicamentoData.cantidad > 0) {
          costoPorDosis = Number((medicamentoData.costoPorFrasco / medicamentoData.cantidad).toFixed(2));
        }
        
        // Si el costo por dosis calculado es diferente al almacenado, actualizar en Firestore
        if (costoPorDosis !== medicamentoData.costoPorDosis) {
          const medicamentoRef = doc(db, "medicamentos", medicamentoId);
          await updateDoc(medicamentoRef, {
            costoPorDosis: costoPorDosis
          });
          
          // Actualizar el valor en medicamentoData para usarlo en el inventario
          medicamentoData.costoPorDosis = costoPorDosis;
        }
        
        // Crear el objeto medicamento para el inventario
        const medicamento = {
          id: medicamentoId,
          nombre: medicamentoData.nombre,
          cantidad: medicamentoData.cantidad,
          miligramos: medicamentoData.miligramos,
          miligramosPorDosis: medicamentoData.miligramosPorDosis,
          dosisPorFrasco: medicamentoData.dosisPorFrasco,
          costoPorFrasco: medicamentoData.costoPorFrasco,
          margenGanancia: medicamentoData.margenGanancia || 0,
          costoPorDosis: medicamentoData.costoPorDosis,
          precioVentaPorDosis: medicamentoData.precioVentaPorDosis,
          estado: medicamentoData.estado,
          unidad: medicamentoData.dosisPorFrasco == 0 ? 0 : medicamentoData.dosisPorFrasco / medicamentoData.cantidad,
          img: medicamentoData.img
        };
        
        if (medicamento.unidad <= 10) {
          this.mostrarToast(
            `Advertencia: ${medicamento.nombre} tiene una cantidad baja (${medicamento.unidad}).`
          );
        }
        
        this.inventario.push(medicamento);
      }
    },
    mostrarToast(mensaje) {
      // Crear un elemento div para el toast
      const toast = document.createElement("div");
      toast.className =
        "flex items-center w-full max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800";
      toast.innerHTML = `
        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-red-500 bg-red-100 rounded-lg dark:bg-red-800 dark:text-red-200">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M18 8A8 8 0 118 0a8 8 0 0110 8zm-9-3h2v4H9V5zm0 6h2v2H9v-2z" clip-rule="evenodd"></path>
          </svg>
        </div>
        <div class="ml-3 text-sm font-normal">${mensaje}</div>
        <button type="button" class="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700" aria-label="Close">
          <span class="sr-only">Cerrar</span>
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1l12 12m0-12L1 13"/>
          </svg>
        </button>
      `;

      // Agregar funcionalidad para cerrar el toast
      toast.querySelector("button").addEventListener("click", () => {
        toast.remove();
      });

      // Agregar el toast al contenedor
      const toastContainer = document.getElementById("toast-container");
      toastContainer.appendChild(toast);
      // Eliminar automáticamente después de 5 segundos

    },
  },
  mounted() {
    this.cargarInventario();
    this.cargarMedicamentosExistentes();
  }
};
</script>


<style scoped>
table th,
table td {
  word-wrap: break-word;
  max-width: 200px;
  /* Ajusta según sea necesario */
}
</style>